module.exports = __webpack_public_path__ + "static/mainImg-3a34f8da766723c54001cf7145b207ca.jpg";